import { useEffect, useState } from "react";
import api from "@/lib/api";
import { PlugZap, Zap, Wifi, WifiOff } from "lucide-react";

const kw = (w) => (w == null ? "—" : `${(w / 1000).toFixed(1)} kW`);
const STATO = { in_ricarica: "In ricarica", disponibile: "Disponibile", in_sosta: "In sosta", errore: "Errore", offline: "Offline" };

export function EvStationsCard({ plantId }) {
  const [list, setList] = useState(null);
  useEffect(() => {
    let vivo = true;
    api.get(`/ev/plants/${encodeURIComponent(plantId)}/stations`)
      .then((r) => { if (vivo) setList(r.data?.stations || []); })
      .catch(() => { if (vivo) setList([]); });
    return () => { vivo = false; };
  }, [plantId]);

  if (!list || list.length === 0) return null;
  return (
    <div className="space-y-2 rounded-xl border border-neutral-800 p-3" data-testid="plant-ev-stations">
      <div className="flex items-center gap-1.5 text-[10px] font-bold uppercase tracking-widest text-neutral-400">
        <PlugZap className="h-3.5 w-3.5" />Ricarica EV
        <span className="ml-1 rounded-full bg-primary/20 px-2 py-0.5 text-[10px] font-bold text-primary">{list.length}</span>
      </div>
      {list.map((s) => (
        <div key={s.id} className="flex items-center gap-3 rounded-lg border border-neutral-800 px-3 py-2 text-sm" data-testid={`plant-ev-station-${s.id}`}>
          {s.online ? <Wifi className="h-4 w-4 text-emerald-500" /> : <WifiOff className="h-4 w-4 text-neutral-500" />}
          <span className="min-w-0 flex-1 truncate text-white">{s.nome || s.ocpp_id}</span>
          <span className="text-xs text-neutral-400">{STATO[s.stato] || s.stato}</span>
          <span className="flex items-center gap-1 font-mono font-bold text-primary"><Zap className="h-3.5 w-3.5" />{kw(s.potenza_w)}</span>
        </div>
      ))}
    </div>
  );
}
